import { useQuery } from "@tanstack/react-query";
import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";
import type { Workflow } from "~/types/api";

const getWorkflowsQueryKey = () => configurationApi.queryOptions("get", "/api/Workflow").queryKey;

export const useWorkflows = () => {
  const { showToast } = useToast();
  const { data, isLoading, error, refetch } = useQuery<Workflow[]>({
    queryKey: getWorkflowsQueryKey(),
    queryFn: async () => {
      const response = await configurationApi.client.GET("/api/Workflow");
      if (response.error) {
        const errorMessage = `Failed to fetch workflows: ${response.error.toString()}`;
        showToast("error", "Error", errorMessage);
        throw new Error(errorMessage);
      }
      return response.data || [];
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    workflows: data || [],
    isLoading,
    error,
    refetch,
  };
};

export const useWorkflow = (workflowId: number | undefined) => {
  const { workflows, isLoading, error } = useWorkflows();

  const workflow = workflowId ? workflows.find((w) => w.id === workflowId) : undefined;

  return {
    workflow,
    isLoading,
    error,
  };
};
